import { render } from "./EntityLink.vue?vue&type=template&id=0bac77a1"
import script from "./EntityLink.vue?vue&type=script&lang=js"
export * from "./EntityLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__